export default "__VITE_ASSET__BsHHDiuw__"